import {SEISMIC_HOIST_TAG_NAME} from '../../constants';

export function wasActionDispatchedByDescendant(composedPath, host) {
	/*
		action was dispatched from within hook or event handlers in view

		view(state, {dispatch}) {
			return (
				<div>
					<p on-click={() => dispatch('SN-BUTTON#BUTTON_CLICKED', {})}>I am a paragraph. Click me.</p>
				</div>
			);
		}
	 */
	if (!composedPath.length) return true;

	let slotted = false;
	for (let i = 0; i < composedPath.length; i++) {
		const el = composedPath[i];
		if (el.tagName === 'SLOT') slotted = true;

		if (el.host) {
			/*
				if the first shadowRoot encountered belongs to the host and a slot is not in the path
				e.g., button dispatches and component that owns view should handle

				view() {
					return <p><sn-button></sn-button></p>;
				}
			 */
			if (el.host === host || el.host.tagName === SEISMIC_HOIST_TAG_NAME)
				return slotted ? false : true;

			/*
				if content is slotted and first shadowRoot encountered does not belong to the host
				e.g., button dispatches and component that owns view should handle

				view() {
					return <slotted-child><sn-button></sn-button></slotted-child>;
				},
			 */
			return slotted ? true : false;
		}
	}
}
